const tableClearingCustomStyles = {
  
    headCells: {
      style: {
        fontSize: '11px',
        fontWeight: 'bold',
        paddingLeft: '4px',
        paddingRight: '4px',

        backgroundColor: '#F8F9FA',
        height: '40px',
        borderBottomWidth: '1px', 
        borderBottomColor: '#CECECE',
			  borderBottomStyle: 'solid',
      },
    },
    head: {
      style: {
        height: '40px',
        
      },
    },
    rows: {
      style: {
        minHeight: '80px', // override the row height
        fontWeight: 'semi-bold',
        fontSize: '11px',
        cursor: 'pointer'
      },
    }
  }

  
export default tableClearingCustomStyles ;